import { RouteComponentProps, useLocation } from "@gatsbyjs/reach-router";
import { APCard, APColumn, APImage, APSizedBox, APText, getIt, handleErrorMessage, showErrorDialog } from "ap-components";
import React, { useEffect, useState } from "react";
import SharedPrefs from "../../Services/SharedPrefs";
import MandateModel from "../../Models/Mandate";
import LoadingState from "./LoadingState";
import MutualFundApiServices from "../../Services/MutualFundServices";

export default function SetupComplete(props: RouteComponentProps<{ mandateId: string }>) {
    const [mandate, setMandate] = useState<MandateModel>();
    const location = useLocation();

    const token = new URLSearchParams(location.search).get("tkn");
    if (token) {
        getIt(SharedPrefs).setItem("mandateTkn", token);
    }

    useEffect(() => {
        getMandate()
    }, [])

    const mandateToken = getIt(SharedPrefs).getItem('mandateTkn');
    if (!mandateToken) {
        window.location.href = "/"
        showErrorDialog("Unauthorized Access");
        return <></>
    }

    if (!props.mandateId) {
        window.history.back();
        showErrorDialog("Please select correct mandate");
        return <></>
    }

    async function getMandate() {
        if (!mandateToken || !props.mandateId) {
            return
        }

        try {
            const res = await getIt(MutualFundApiServices).getMandate(props.mandateId, mandateToken);
            setMandate(res);
        } catch (error) {
            handleErrorMessage(error);
        }
    }

    if (!mandate) {
        return <LoadingState />
    }

    let mandateType = mandate.getMandateType();

    let mandateActivationText = 'in 30-45 days';
    // if (mandateType == 'UpiMandate') {
    //     mandateActivationText = `immediately after approval in your ${MandateModel.getUpiAppName(mandate.upiId)}`;
    // }
    if (mandateType == "Online") {
        mandateActivationText = 'in 2-3 business days';
    }

    return (
        <APColumn mainAxisAlignment="center" style={{ padding: "16px" }} mainAxisSize="max">
            <APCard style={{ borderRadius: "8px", padding: "16px", width: "min(100%, 500px)" }}>
                <APColumn>
                    <APText style={{ fontWeight: 500, lineHeight: 1.33, color: "#232730", fontSize: "24px" }}>
                        Setup Complete
                    </APText>
                    <APSizedBox height="24px" />
                    <APImage src={"/img/ic_stamp.svg"} />
                    <APSizedBox height="24px" />
                    <APText style={{ fontSize: "16px", lineHeight: 1.5, color: "#232730", textAlign: "center" }}>
                        AutoPay will be enabled {mandateActivationText}.
                    </APText>
                    <APText style={{ fontSize: "16px", lineHeight: 1.5, color: "#232730" }}>
                        Thank you!
                    </APText>
                </APColumn>
            </APCard>
        </APColumn>)

}